import * as actionTypes from '../actionTypes/App'

export const handleDeepLinking = data => {
    return {
        type: actionTypes.HANDLE_DEEP_LINKING,
        data,
    }
}

export const updateEnvironment = value => {
    return {
        type: actionTypes.UPDATE_ENVIRONMENT,
        value,
    }
}
